module.exports = __webpack_public_path__ + "img/png_jsgzl_3@2x.6be8341e.png";